import { createContext, useContext, useEffect, useId } from 'react'

export const Notices = createContext<((id: string, text: string | null) => void) | null>(null)

/** Nested reads stay mounted when folded; their failures must remain discoverable. */
export function useFundSectionNotice(text: string | null) {
  const report = useContext(Notices)
  const id = useId()
  useEffect(() => {
    report?.(id, text)
    return () => report?.(id, null)
  }, [id, text, report])
}
